import { atom } from 'jotai';
import { ModelImage } from '@acme/db';

export const UPSCALE_YOUR_LIKED_PHOTO_DIALOG_ID = 'like-photo-dialog';

interface UpscaleYourLikedPhotoDialogState {
  open: boolean;
  modelId?: string;
  image?: ModelImage;
  albumId?: string;
}

export const UpscaleYourLikedPhotoDialogOpenAtom = atom<UpscaleYourLikedPhotoDialogState>({
  open: false,
  modelId: undefined,
  image: undefined,
  albumId: undefined
}); 